import { useState } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";
import { motion, AnimatePresence } from "framer-motion";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Logo from "./icons/Logo";

type CookiePreferencesModalProps = {
  onClose: () => void;
};

export function CookiePreferencesModal({
  onClose,
}: CookiePreferencesModalProps) {
  const { updatePreferences, preferences: cookiePreferences } =
    useCookieConsent();
  const [currentTab, setCurrentTab] = useState<number | null>(0);
  const [preferences, setPreferences] = useState({
    preference: false,
    marketing: false,
    statistics: true,
  });

  console.log({ cookiePreferences });

  const handleAcceptAll = () => {
    updatePreferences({ statistics: true, marketing: true, preference: true });
    onClose();
  };

  const handleSave = () => {
    updatePreferences(preferences);
    onClose();
  };

  const handleRejectAll = () => {
    updatePreferences({
      statistics: false,
      marketing: false,
      preference: false,
    });
    onClose();
  };

  const handleChangeTab = (tab: number) => {
    if (currentTab === tab) setCurrentTab(null);
    else setCurrentTab(tab);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-lg w-full h-full md:w-[575px] md:h-auto overflow-auto">
        <div className="flex justify-between items-center mb-2 border-b border-gray-300 p-4">
          <Logo className="w-[180px] h-[40px]" />
          <button onClick={onClose}>X</button>
        </div>

        <div className="md:max-h-[530px] overflow-auto">
          <div className="flex flex-col gap-2 p-4 font-light">
            <span className="font-bold">
              Centro de preferências de privacidade
            </span>
            <p className="text-sm">
              Os cookies são pequenos arquivos de texto que podem ser usados
              pelos sites para tornar a experiência do usuário mais eficiente.
            </p>
            <p className="text-sm">
              A legislação determina que podemos armazenar cookies no seu
              dispositivo caso sejam estritamente necessários para a operação
              deste site. Para todos os outros tipos de cookies, precisamos da
              sua permissão.
            </p>
            <p className="text-sm">
              Este site usa diferentes tipos de cookies. Alguns cookies são
              instalados por serviços de terceiros que são exibidos nas nossas
              páginas.
            </p>
            <p className="text-sm">
              Você pode alterar ou revogar seu consentimento à Declaração de
              Cookies a qualquer momento no nosso site.
            </p>
            <p className="text-sm">
              Saiba mais sobre quem somos, como entrar em contato conosco e como
              processamos seus dados pessoais na nossa{" "}
              <a
                className="underline text-sky-800"
                href="#/politica-de-privacidade"
                target="_blank"
              >
                Política de Privacidade
              </a>
              .
            </p>
            <p className="text-sm">
              Informe sua ID e data de consentimento ao entrar em contato
              conosco para tratar do seu consentimento.
            </p>

            <div className="py-4">
              <Button label="Permitir Todos" onClick={handleAcceptAll} />
            </div>

            <div>
              <p className="text-[#696969] text-lg font-bold py-4">
                Gerir preferências de cookies
              </p>

              <div className="border border-gray-300">
                {/* Cookies Necessários */}
                <div className="flex items-center justify-between border-b border-gray-300 cursor-pointer">
                  <p
                    className="font-bold w-full flex justify-between p-4"
                    onClick={() => handleChangeTab(0)}
                  >
                    Cookies Necessários
                    <div className="flex">
                      <span className="text-blue-700 font-light">
                        Sempre Ativo
                      </span>
                      <button onClick={() => handleChangeTab(0)}>
                        <AnimatedArrow
                          isOpen={currentTab === 0}
                          onClick={() => handleChangeTab(0)}
                        />
                      </button>
                    </div>
                  </p>
                </div>
                <AnimatePresence>
                  {currentTab === 0 && (
                    <motion.div
                      key="tab-0"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="p-4 bg-gray-100">
                        <span>
                          Os cookies necessários ajudam a tornar o site
                          utilizável, habilitando funções básicas, como
                          navegação pelas páginas e acesso às áreas seguras do
                          site. O site não funciona corretamente sem esses
                          cookies.
                        </span>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>

                {/* Cookies de Preferências */}
                <div className="flex items-center justify-between cursor-pointer border-b border-gray-300">
                  <p
                    className="font-bold w-full p-4"
                    onClick={() => handleChangeTab(1)}
                  >
                    Cookies de Preferências
                  </p>
                  <div className="p-4">
                    <div className="flex gap-2">
                      <div className="flex items-center gap-1">
                        <Toogle
                          setState={() => {
                            setPreferences({
                              ...preferences,
                              preference: !preferences.preference,
                            });
                          }}
                          state={preferences.preference}
                        />
                        <button onClick={() => handleChangeTab(1)}>
                          <AnimatedArrow
                            isOpen={currentTab === 1}
                            onClick={() => handleChangeTab(1)}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <AnimatePresence>
                  {currentTab === 1 && (
                    <motion.div
                      key="tab-1"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="p-4 bg-gray-100">
                        <span>
                          Os cookies de preferência permitem que o site se
                          lembre das informações que alteram sua aparência ou a
                          maneira como ele se comporta, como seu idioma
                          preferido ou a região onde você está.
                        </span>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>

                {/* Cookies de Estatísticas */}
                <div className="flex items-center justify-between cursor-pointer border-b border-gray-300">
                  <p
                    className="font-bold w-full p-4"
                    onClick={() => handleChangeTab(2)}
                  >
                    Cookies de Estatísticas
                  </p>
                  <div className="p-4">
                    <div className="flex gap-2">
                      <div className="flex items-center gap-1">
                        <Toogle
                          setState={() => {
                            setPreferences({
                              ...preferences,
                              statistics: !preferences.statistics,
                            });
                          }}
                          state={preferences.statistics}
                        />
                        <button onClick={() => handleChangeTab(2)}>
                          <AnimatedArrow
                            isOpen={currentTab === 2}
                            onClick={() => handleChangeTab(2)}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <AnimatePresence>
                  {currentTab === 2 && (
                    <motion.div
                      key="tab-2"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="p-4 bg-gray-100">
                        <span>
                          Os cookies estatísticos ajudam os proprietários a
                          identificar quantos visitantes interagem com seus
                          sites, coletando e relatando informações de forma
                          anônima.
                        </span>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>

                {/* Cookies de Marketing */}
                <div className="flex items-center justify-between cursor-pointer border-b border-gray-300">
                  <p
                    className="font-bold w-full p-4"
                    onClick={() => handleChangeTab(3)}
                  >
                    Cookies de Marketing
                  </p>
                  <div className="p-4">
                    <div className="flex gap-2">
                      <div className="flex items-center gap-1">
                        <Toogle
                          setState={() => {
                            setPreferences({
                              ...preferences,
                              marketing: !preferences.marketing,
                            });
                          }}
                          state={preferences.marketing}
                        />
                        <button onClick={() => handleChangeTab(3)}>
                          <AnimatedArrow
                            isOpen={currentTab === 3}
                            onClick={() => handleChangeTab(3)}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <AnimatePresence>
                  {currentTab === 3 && (
                    <motion.div
                      key="tab-3"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="p-4 bg-gray-100">
                        <span>
                          Os cookies de marketing são usados para monitorar os
                          visitantes em diferentes sites. A intenção é exibir
                          anúncios que sejam relevantes e atraentes ao usuários
                          e, portanto, mais vantajosos aos publicadores e
                          anunciantes terceiros.
                        </span>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 p-4">
          <Button label="Rejeitar Todos" onClick={handleRejectAll} />
          <Button
            label="Confirmar as minhas preferências"
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
}

const Button = ({ label, onClick }: { label: string; onClick: () => void }) => {
  return (
    <button
      type="button"
      className="font-bold w-max text-sm rounded border border-secondary px-4 py-2 transition-all duration-300 hover:opacity-80 bg-secondary text-white"
      onClick={onClick}
    >
      {label}
    </button>
  );
};

const Toogle = ({
  state,
  setState,
}: {
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <div
      className={`relative w-[40px] h-[20px] rounded-full cursor-pointer p-1 flex items-center transition-colors ${
        state ? "bg-secondary" : "bg-[#ACB2B6]"
      }`}
      onClick={() => setState(!state)}
    >
      <motion.div
        className="size-4 bg-white rounded-full shadow-md"
        layout
        initial={false}
        animate={{ x: state ? 18 : -1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      />
    </div>
  );
};

const AnimatedArrow = ({
  isOpen,
  onClick,
}: {
  isOpen: boolean;
  onClick: () => void;
}) => {
  return (
    <motion.div
      onClick={onClick}
      initial={{ rotate: 0 }}
      animate={{ rotate: isOpen ? 90 : 0 }}
      transition={{ duration: 0.3 }}
      className="flex items-center"
    >
      <MdOutlineKeyboardArrowRight />
    </motion.div>
  );
};
